const CLOUDINARY_BUCKET = 'rcenter';
const DOMAIN_WITHOUT_PROTOCOL = process.env.DOMAIN_WITHOUT_PROTOCOL || 'bondsports.local';
const API_DOMAIN = `https://${DOMAIN_WITHOUT_PROTOCOL}`;

export const environment = {
	production: `${process.env.PRODUCTION || false}` === 'true',
	INTERCOM_ID: process.env.INTERCOM_ID || 'rk54jlxy',
	STRIPE_KEY: process.env.STRIPE_KEY || 'pk_test_AM4q8Ui1y3iFC2t0YryIRpux00xuUkH1hA',
	CLOUDINARY_BUCKET: process.env.CLOUDINARY_BUCKET || CLOUDINARY_BUCKET,
	CLOUDINARY_ROOT: process.env.CLOUDINARY_ROOT || 'https://res.cloudinary.com/' + CLOUDINARY_BUCKET + '/image/upload',
	CLOUDINARY_API_ROOT: process.env.CLOUDINARY_API_ROOT || 'https://api.cloudinary.com/v1_1/' + CLOUDINARY_BUCKET + '/image/upload',
	CLOUDINARY_UPLOAD_PRESET: process.env.CLOUDINARY_UPLOAD_PRESET || 'tm4almj6',
	CLOUDINARY_UPLOAD_PRESET_WITH_CROPPING: process.env.CLOUDINARY_UPLOAD_PRESET_WITH_CROPPING || 'tm4almj6_dupe_with_incoming_crop',
	GOOGLE_API_KEY: process.env.GOOGLE_API_KEY,
	CS_URLS: {
		API_DOMAIN: process.env.API_DOMAIN || API_DOMAIN,
		API_ROOT_V4: process.env.API_ROOT_V4 || API_DOMAIN + '/v4',
		AUTH_ROOT: process.env.AUTH_ROOT || API_DOMAIN + '/auth',
	},
	SITE_URL: process.env.SITE_URL || `https://backoffice.${DOMAIN_WITHOUT_PROTOCOL}/login`,
	PRODUCTION_URL: process.env.PRODUCTION_URL || 'backoffice.bondsports.co',
	CONSUMER_SITE_URL: process.env.CONSUMER_SITE_URL || `https://consumer.${DOMAIN_WITHOUT_PROTOCOL}`,
	SLACK_NOTIFICATIONS: process.env.SLACK_NOTIFICATIONS || 'https://hook.eu1.make.com/zisii0jole6shgbhedds4828u998vig9',
	DEBUG_RECOIL: `${process.env.DEBUG_RECOIL || false}` === 'true',
	LOGIN_REDIRECT_URL: `${API_DOMAIN}/auth/redirect/login`,
	LOGOUT_REDIRECT_URL: `${API_DOMAIN}/auth/redirect/logout`,
	TERMS_OF_CONDITIONS_URL: `${API_DOMAIN}}/statics/terms.html`,
	QLIK_REPORTING_BASE_URL: process.env.QLIK_REPORTING_BASE_URL || 'https://bondsports.us.qlikcloud.com/',
	REPORTING_BASE_URL: process.env.REPORTING_BASE_URL || 'https://app.sigmacomputing.com/bond-sports',
};
